import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRocket,faHeart,faBook } from '@fortawesome/free-solid-svg-icons';
const BlogDetails = () => {


  return (
    <>

<div className='flex justify-evenly items-center md:flex-row'>


<div className="p-4 md:p-10 max-w-sm  rounded-lg bg-indigo-400 text-indigo-900">

    <div className="flex flex-col items-center">
    <FontAwesomeIcon icon={faBook} className="text-2xl mt-2 mb-2"/>
        <h5 className="mb-1 text-xl md:text-3xl font-extrabold">900+</h5>
        <span className="text-md font-semibold">Reads</span>
    </div>
</div>

<div className="p-5 md:p-14 max-w-sm rounded-lg borde shadow-md bg-green-400 text-green-900 border-gray-700">

    <div className="flex flex-col items-center">
        <FontAwesomeIcon icon={faRocket} className="text-2xl mt-2 mb-2" />
        <h5 className="mb-1 text-xl md:text-3xl font-extrabold">1700+</h5>
        <span className="text-md font-semibold">Views</span>
    </div>
</div>

<div className="p-4 md:p-10 max-w-sm rounded-lg bg-purple-400 text-purple-900">
    <div className="flex flex-col items-center">       
        <FontAwesomeIcon icon={faHeart} className="text-2xl mt-2 mb-2"/>
        <h5 className="mb-1 text-xl md:text-3xl font-extrabold">400+ </h5>
        <span className="text-md font-semibold text-center leading-4">Claps</span>
    </div>
</div>


</div>


    </>
  )
}

export default BlogDetails